<div class="import-modal">
  <div class="import-modal-header">
    <span>Import File</span>
    <button class="close-btn" (click)="closeDialog()">×</button>
  </div>

  <div class="import-modal-body">
    <div class="import-via-url-btn w-100 mb-3">Import file via URL</div>
    <div class="row g-2 align-items-center">
      <div class="col-3 mt-0">
        <select id="fileType" class="form-control url-dropdown" [(ngModel)]="selectedFileType">
          @for (type of fileTypes; track type) {
            <option [value]="type">{{ type }}</option>
          }
        </select>
      </div>
      <div class="col-9">
        <input type="text" class="form-control" [(ngModel)]="fileUrl" placeholder="Import file via URL" />
      </div>
    </div>

    <div class="import-modal-footer">
      <button class="ok-btn" (click)="onImport()">OK</button>
      <button class="cancel-btn" (click)="onCancel()">Cancel</button>
    </div>
  </div>
